export class CcfacRange {
    orgElementCode: string;
    description: string;
    rangeFrom: number;
    rangeTo: number;
}


